import axios from "axios";

export default {
  state: () => ({
    activeTopic: {},
    lang: "fi_FI",
    uniqueTypes: [],
    uniqueSidePanelCategories: [],
    activeComponent: "",
    activeSubComponent: "",
    // side panel wide
    activeSidePanelData: {},
    categories: [],
    topics: new Map()
  }),
  mutations: {
    SET_ACTIVE_TOPIC: (state, data) => {
      state.activeTopic = data;
    },
    SET_ACTIVE_DATA_TYPE: (state, componentId) => {
      state.activeComponent = componentId;
    },
    SET_LANG: (state, lang) => {
      state.lang = lang;
    },
    SET_UNIQUE_TYPES: (state, data) => {
      state.uniqueTypes = [...new Set(data.map((topic) => topic.type))];
    },
    SET_CATEGORY_DATA: (state, data) => {
      state.categories = data;
    },
    SET_TOPIC_DATA: (state, data) => {
      state.topics.set(data.id, data.topics);
    },
    ACTIVE_BUTTON: (state, buttonData) => {
      state.activeSidePanelData = buttonData;
    },
  },
  actions: {
    activateSidePanelData: ({ commit }, buttonData) => {
      commit("ACTIVE_BUTTON", buttonData);
    },
    initCategoryData: async ({ commit, getters }) => {
      const url = `${location.protocol}//${location.host}${location.pathname}`;
      const target = `?p_p_id=fi_yja_componentgallery_ComponentGalleryRestPortlet&p_p_lifecycle=2&p_p_resource_id=/get-gc`;
      const locale = `&locale=${getters.getLanguage}`;
      const action = `&action=list-category`

      const response = await axios.get(`${url}${target}${locale}${action}`);
      commit("SET_CATEGORY_DATA", response.data.categories)
    },
    initTopicData: async ({ commit, getters }, categoryId) => {
      const url = `${location.protocol}//${location.host}${location.pathname}`;
      const target = `?p_p_id=fi_yja_componentgallery_ComponentGalleryRestPortlet&p_p_lifecycle=2&p_p_resource_id=/get-gc`;
      const locale = `&locale=${getters.getLanguage}`;
      const action = `&action=list-topic&category-id=${categoryId}`

      const response = await axios.get(`${url}${target}${locale}${action}`);
      commit("SET_TOPIC_DATA", {
        id: categoryId,
        topics: response.data.topics
      })
    },
    initComponentPageData: async ({ commit, getters }, id) => {
      const response = await axios
        .get(
          `${location.protocol}//${location.host}${location.pathname}?p_p_id=fi_yja_componentgallery_ComponentGalleryRestPortlet&p_p_lifecycle=2&p_p_resource_id=/get-gc&locale=${getters.getLanguage}&action=get-topic&topic-id=${id}`
        );
      commit("SET_ACTIVE_TOPIC", response.data.topics[0]);
      commit("SET_UNIQUE_TYPES", response.data.topics[0].components);
    },
    setActiveDataType: ({ commit }, dataType) => {
      commit("SET_ACTIVE_DATA_TYPE", dataType);
    },
    setActiveTopic: ({ commit }, data) => {
      commit("SET_ACTIVE_TOPIC", data);
    },
    setLang: ({ commit }, lang) => {
      commit("SET_LANG", lang);
    },
  },

  getters: {
    getActiveSubComponent: (state) => {
      return state.activeSubComponent;
    },
    getActiveDataType: (state) => {
      return state.activeComponent;
    },
    getLanguage: (state) => {
      return state.lang;
    },
    getName: (state) => {
      return state.activeTopic.name;
    },
    getContentHTML: (state) => {
      return state.activeTopic.content;
    },
    getDataByType: (state) => (dataType) => {
      let objects = [];
      if (state.activeTopic.components) {
        objects = state.activeTopic.components.filter((obj) => {
          return obj.type === dataType;
        });
      }
      return objects;
    },
    getCurrFacadeImage: (state) => {
      return (state.activeTopic.images || []).find((obj) => obj.type === "Julkisivukuva");
    },
    getCurrCutImage: (state) => {
      return (state.activeTopic.images || []).find(
        (obj) => obj.type === "Poikkileikkauskuva" && obj.defaultImage === true
      );
    },
    getAllImgHighLight: (state) => {
      const imageClassArray = [];
      if (state.activeTopic.images) {
        for (let i = 0; i < state.activeTopic.images.length; i++) {
          if ("imageClass" in state.activeTopic.images[i]) {
            imageClassArray.push(state.activeTopic.images[i]);
          }
        }
      }
      return imageClassArray;
    },
    getUniqueDataTypes: (state) => {
      return state.uniqueTypes;
    },
    /**
     * if current component has linked components, offer those for frontend 
     * @param {*} state 
     * @returns 
     */
    getLinkedComponents: (state) => {
      const releatedComponents = [];

      for (let i = 0; i < state.activeSidePanelData.componentLinks.length; i++) {
        let componentArray = state.activeTopic.components.filter((obj) => {
          return obj.id === state.activeSidePanelData.componentLinks[i].relComponentId;
        });
        if (!componentArray.length) {
          for (let j = 0; j < state.activeTopic.components.length; j++) {
            componentArray = state.activeTopic.components[j].subComponents.filter((obj) => {
              return obj.id === state.activeSidePanelData.componentLinks[i].relComponentId;
            });

            if (componentArray.length) {
              break;
            }
          }
        }
        releatedComponents.push(componentArray);
      }
      return releatedComponents;
    },
    //active side panel wide
    // used to get focused button for styles
    activeSidePanelData: (state) => {
      return state.activeSidePanelData;
    },
    getUniqueSidePanelCategories: (state) => (objData) => {
      let activeDataObj = [];
      let activeTargetObj = [];
      let currUniqueSet;
      if (state.activeTopic.components) {
        activeDataObj = state.activeTopic.components.filter((obj) => {
          return obj.type === state.activeComponent;
        });
      }
      if (activeDataObj) {
        activeTargetObj = activeDataObj.filter((obj) => {
          return obj.name === objData;
        });
      }
      if (activeTargetObj[0].subComponents) {
        const currSubComponents = activeTargetObj[0].subComponents;
        currUniqueSet = [...new Set(currSubComponents.map((subComponent) => subComponent.type))];
      }
      return currUniqueSet;
    },
    getSidePanelAccordionContent: (state) => (payload) => {
      return state.activeSidePanelData.subComponents.filter((subComponent) => {
        return subComponent.type === payload;
      });
    },
    getCategoryTopics: (state) => (categoryId) => {
      return state.topics.get(categoryId);
    },
    getCategories: (state) => {
      return state.categories;
    },
  },
};
